import { Button, Col, ControlLabel, FormControlStatic, Modal, Row } from 'react-bootstrap';
import { ICenterAddress } from '@nkr/models/center-address';

interface IProps {
    show: boolean,
    data: ICenterAddress,
    onYes: () => void,
    onNo: () => void
}

const ConfirmDelete = (props: IProps) => {
    if (props.data == null)
        return null;

    const { typeName, addressLine1, addressLine2, addressLine3, city, stateAbbreviation, postalCode } = props.data;

    return (
        <Modal backdrop='static' show={props.show} onHide={props.onNo}>
            <Modal.Header closeButton>
                <Modal.Title>
                    Confirm Address Delete
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className='text-center' style={{ marginBottom: 10 }}>Are you sure you want to delete the following address?</div>

                <Row>
                    <Col xs={12} lg={6} componentClass={ControlLabel} style={{ textAlign: 'right' }}>Type:</Col>
                    <Col xs={12} lg={6} componentClass={FormControlStatic}>{typeName}</Col>
                </Row>
                <Row>
                    <Col xs={12} lg={6} componentClass={ControlLabel} style={{ textAlign: 'right' }}>Address:</Col>
                    <Col xs={12} lg={6} componentClass={FormControlStatic}>
                        <div>{addressLine1}</div>
                        <div>{addressLine2}</div>
                        <div>{addressLine3}</div>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} lg={6} componentClass={ControlLabel} style={{ textAlign: 'right' }}>City, State:</Col>
                    <Col xs={12} lg={6} componentClass={FormControlStatic}>{city}, {stateAbbreviation}</Col>
                </Row>
                <Row>
                    <Col xs={12} lg={6} componentClass={ControlLabel} style={{ textAlign: 'right' }}>Postal Code:</Col>
                    <Col xs={12} lg={6} componentClass={FormControlStatic}>{postalCode}</Col>
                </Row>
            </Modal.Body>

            <Modal.Footer>
                <Button bsStyle='danger' onClick={props.onYes}>Yes, Delete</Button>
                <Button onClick={props.onNo}>No, Cancel</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ConfirmDelete;